import rTheme from '../../src/ui/theme'

type TDevice =
  | 'mobile'
  | 'tablet'
  | 'desktop'
  | 'upMobile'
  | 'mobileXss'
  | 'desktopLg'
  | 'desktopXl'
export const getMediaQuery = (
  theme: typeof rTheme,
  device: TDevice = 'mobile'
) => {
  switch (device) {
    case 'mobileXss':
      return theme.breakpoints.down('xss')
    case 'mobile':
      return theme.breakpoints.down('md')
    case 'upMobile':
      return theme.breakpoints.up('sm')
    case 'tablet':
      return theme.breakpoints.down('lg')
    case 'desktop':
      return theme.breakpoints.up('md')
    case 'desktopLg':
      return theme.breakpoints.down('xl3')
    case 'desktopXl':
      return theme.breakpoints.up('xl')
    default:
      return theme.breakpoints.down('sm')
  }
}
